/**
 * fancyboxGallery Component
 *
 * @file slider.js
 */
import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "jquery-ui/themes/base/all.css";
import datepickerFactory from 'jquery-datepicker';
import datepickerTR from 'jquery-datepicker/i18n/jquery.ui.datepicker-tr';
import datepickerEN from 'jquery-datepicker/i18n/jquery.ui.datepicker-en-GB';


const fancyboxGallery = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const defaultFancybox = () => {
    Fancybox.bind('[data-fancybox]', {
      // Custom options for all galleries
    }); 
    Fancybox.bind('[data-fancybox="home-video-gallery"]', {
      // Custom options for all galleries
      Thumbs:false
    }); 
    $('.cookie-accept').on('click', function(){
      Fancybox.bind.close();
    });  
  };

  const defaultdatePicker = () => {
    datepickerFactory($);
    datepickerTR($);
    datepickerEN($);
    
    $( function() {
      if ( document.documentElement.lang.toLowerCase() === "tr" ) {
        $.datepicker.setDefaults($.datepicker.regional['tr']);
      } else{
        $.datepicker.regional['en'] = { // Default regional settings
          closeText: "Done", // Display text for close link
          prevText: "Prev", // Display text for previous month link
          nextText: "Next", // Display text for next month link
          currentText: "Today", // Display text for current month link
          monthNames: [ "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December" ], // Names of months for drop-down and formatting
          monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ], // For formatting
          dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ], // For formatting
          dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ], // For formatting
          dayNamesMin: [ "Su", "Mo", "Tu", "We", "Th", "Fr", "Sa" ], // Column headings for days starting at Sunday
          weekHeader: "Wk", // Column header for week of the year
          dateFormat: "d M, y", // See format options on parseDate
          firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
          isRTL: false, // True if right-to-left language, false if left-to-right
          showMonthAfterYear: false, // True if the year select precedes month, false for month then year
          yearSuffix: "", // Additional text to append to the year in the month headers,
          selectMonthLabel: "Select month", // Invisible label for month selector
          selectYearLabel: "Select year" // Invisible label for year selector
        };
        $.datepicker.setDefaults($.datepicker.regional['en']);
      }
      var dateFormat = "d M, y",
        from = $("#dateFrom" )
          .datepicker({
            defaultDate: "+1w",
            changeMonth: true,
            numberOfMonths: 1,
            minDate:0,
            dateFormat: "d M y",
          })
          .on( "change", function() {
            to.datepicker( "option", "minDate", getDate( this ) );
          }),
        to = $( "#dateTo" ).datepicker({
          defaultDate: "+1w",
          changeMonth: true,
          numberOfMonths: 1,
          dateFormat: "d M y",
          beforeShow: function() {
            $(this).datepicker('option', 'minDate', $('#dateFrom').val());
            if ($('#dateFrom').val() === '') $(this).datepicker('option', 'minDate', 0);                             
        }
        })
        .on( "change", function() {
          from.datepicker( "option", "maxDate", getDate( this ) );
        });
  
      function getDate( element ) {
        var date;
        try {
          date = $.datepicker.parseDate( dateFormat, element.value );
        } catch( error ) {
          date = null;
        }
  
        return date;
      }


      $('.input-number').each(function() {
        var spinner = $(this),
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.plus'),
            btnDown = spinner.find('.minus'),
            min = input.attr('min'),
            max = input.attr('max');
      
        btnUp.click(function() {
          var oldValue = parseFloat(input.val());
          if (oldValue >= max) {
            var newVal = oldValue;
          } else {
            var newVal = oldValue + 1;
          }
          spinner.find("input").val(newVal);
          spinner.find("input").trigger("change");
        });
      
        btnDown.click(function() {
          var oldValue = parseFloat(input.val());
          if (oldValue <= min) {
            var newVal = oldValue;
          } else {
            var newVal = oldValue - 1;
          }
          spinner.find("input").val(newVal);
          spinner.find("input").trigger("change");
        });
      });

    });
  };

  const init = () => {
    defaultFancybox();
    defaultdatePicker();
  };

  return {
    init,
  };
})();

export default fancyboxGallery;
